var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports__panel--employees"},[_c('b-field',{attrs:{"label":"Navn"}},[_c('b-autocomplete',{ref:"autocomplete",attrs:{"data":_vm.employeesFiltered,"custom-formatter":function (value) { return ((value.number) + " - " + (value.name)); }},on:{"typing":_vm.typing,"select":function (option) {
          this$1.selected = option;
          this$1.$emit('employeeId', option ? option.id : undefined);
          this$1.$emit(
            'employeeNumberChanged',
            option ? option.number : undefined
          );
          this$1.$emit('employeeName', option ? option.name : undefined);
        }},model:{value:(_vm.employee),callback:function ($$v) {_vm.employee=$$v},expression:"employee"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }